@import url('./color.css');
@import url('./typography.css');
@import url('./templates/cards.css');
@import url('./templates/dashboard-navigation.css');
@import url('./templates/dda-footer-main.css');
@import url('./templates/side-navigation.css');
@import url('./templates/table.css');
@import url('./templates/website-footer.css');

@font-face {
  font-family: "Dubai";
  src: url("../assets/fonts/dubai/DubaiLight.eot");
  src: url("../assets/fonts/dubai/DubaiLight.eot") format("embedded-opentype"),
    url("../assets/fonts/dubai/DubaiLight.woff2") format("woff2"),
    url("../assets/fonts/dubai/DubaiLight.woff") format("woff"),
    url("../assets/fonts/dubai/DubaiLight.ttf") format("truetype"),
    url("../assets/fonts/dubai/DubaiLight.svg#DubaiLight") format("svg");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Dubai";
  src: url("../assets/fonts/dubai/DubaiRegular.eot");
  src: url("../assets/fonts/dubai/DubaiRegular.eot") format("embedded-opentype"),
    url("../assets/fonts/dubai/DubaiRegular.woff2") format("woff2"),
    url("../assets/fonts/dubai/DubaiRegular.woff") format("woff"),
    url("../assets/fonts/dubai/DubaiRegular.ttf") format("truetype"),
    url("../assets/fonts/dubai/DubaiRegular.svg#DubaiRegular") format("svg");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Dubai";
  src: url("../assets/fonts/dubai/DubaiMedium.eot");
  src: url("../assets/fonts/dubai/DubaiMedium.eot") format("embedded-opentype"),
    url("../assets/fonts/dubai/DubaiMedium.woff2") format("woff2"),
    url("../assets/fonts/dubai/DubaiMedium.woff") format("woff"),
    url("../assets/fonts/dubai/DubaiMedium.ttf") format("truetype"),
    url("../assets/fonts/dubai/DubaiMedium.svg#DubaiMedium") format("svg");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Dubai";
  src: url("../assets/fonts/dubai/DubaiBold.eot");
  src: url("../assets/fonts/dubai/DubaiBold.eot") format("embedded-opentype"),
    url("../assets/fonts/dubai/DubaiBold.woff2") format("woff2"),
    url("../assets/fonts/dubai/DubaiBold.woff") format("woff"),
    url("../assets/fonts/dubai/DubaiBold.ttf") format("truetype"),
    url("../assets/fonts/dubai/DubaiBold.svg#DubaiBold") format("svg");
  font-weight: 700;
  font-style: normal;
}
:root{
  --font-family-main: 'Dubai', sans-serif;
}
body {
  font-family: "Dubai", Helvetica, sans-serif;
  font-size: var(--dda-fs-body-lg);
  font-weight: var(--dda-fw-400);
  line-height: 1.5;
  color: var(--dda-on-surface-0);
  margin: 0;
}

* {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
  padding: 0;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

a,
a:hover {
  text-decoration: none;
}

button {
  cursor: pointer;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

/*Colors*/
.dda-bg-primary {
  background-color: var(--dda-color-primary-40);
}

.dda-bg-secondary {
  background-color: var(--dda-color-secondary);
}

.dda-color-black {
  color: var(--dda-on-surface-0);
}

/* Border-radius classes */
.dda-rounded-sm {
  border-radius: 4px !important;
}

.dda-rounded-md {
  border-radius: 8px !important;
}

.dda-rounded-lg {
  border-radius: 12px !important;
}

.dda-rounded-circle {
  border-radius: 100px !important;
}

.dda-gap-16 {
  gap: 4rem !important;
}

.dda-gap-12 {
  gap: 3rem !important;
}

.dda-gap-10 {
  gap: 2.5rem !important;
}

.dda-gap-8 {
  gap: 2rem !important;
}

.dda-gap-6 {
  gap: 1.5rem !important;
}

.dda-gap-5 {
  gap: 1.25rem !important;
}

.dda-gap-4 {
  gap: 1rem !important;
}

.dda-gap-3 {
  gap: .75rem !important;
}

.dda-gap-2 {
  gap: .5rem !important;
}

.dda-gap-1 {
  gap: 0.375rem !important;
}


::-ms-input-placeholder {
  color: #8E9191;
}

::placeholder {
  color: #8E9191;
}

.dda-flex {
  display: flex;
}

.dda-flex-column {
  flex-direction: column;
}

.dda-inline-flex {
  display: inline-flex;
}

.dda-align-center {
  align-items: center;
}

.dda-justify-space {
  justify-content: space-between;
}

.dda-justify-center {
  justify-content: center;
}

.m-0 {
  margin: 0px !important;
}

.p-0 {
  padding: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.border-right {
  border-inline-end: solid 1px #E5E5E5;
}

.visually-hidden{
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
